module.exports = __webpack_public_path__ + "img/ronsard.faa91049.jpg";